import { createColumnHelper } from '@tanstack/react-table';
import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import {
    PortfolioEnterpriseProductConfigurationEntry,
    PortfolioEnterpriseProductConfigurationStatus,
} from '@mews-commander/data-access';
import { values } from '@mews/fp';
import { LocalizedEnum, lt } from '@mews/framework';
import { ColumnFilterType, Icon, IconName } from '@optimus-web/core';
import { ViewLocalProductIconButton } from '../LocalProductSidePanel/ViewLocalProductIconButton';

const propertiesTableColumnHelper = createColumnHelper<PortfolioEnterpriseProductConfigurationEntry>();

export const useColumns = (centralProductName: string) => [
    propertiesTableColumnHelper.accessor('property', {
        header: () => lt('Property'),
        enableColumnFilter: true,
        enableSorting: true,
        meta: {
            filtersType: ColumnFilterType.String,
        },
        cell: (props) => {
            const property = props.getValue();
            return property.name;
        },
    }),
    propertiesTableColumnHelper.accessor('city', {
        header: () => lt('City'),
        enableSorting: true,
    }),
    propertiesTableColumnHelper.accessor('country', {
        header: () => lt('Country'),
        enableSorting: true,
    }),
    propertiesTableColumnHelper.accessor('configurationStatus', {
        header: () => lt('Status'),
        enableColumnFilter: true,
        meta: {
            align: 'start',
            filtersType: ColumnFilterType.MultiSelect,
            getMultiSelectOptions: () =>
                pipe(
                    PortfolioEnterpriseProductConfigurationStatus,
                    values,
                    array.map((value) => ({
                        value,
                        label: <LocalizedEnum prefix="EnterpriseProductConfigurationStatus" value={value} />,
                    }))
                ),
        },
        cell: (props) => {
            const isConfigured = props.getValue() === PortfolioEnterpriseProductConfigurationStatus.Configured;
            return isConfigured ? (
                <Icon value={IconName.CheckCircle} variant="success" />
            ) : (
                <Icon value={IconName.AlertCircle} variant="danger" />
            );
        },
    }),
    propertiesTableColumnHelper.display({
        id: 'actions',
        meta: { align: 'end' },
        cell: (props) => {
            const { enterpriseProductId, property } = props.row.original;

            return (
                <ViewLocalProductIconButton
                    localProductId={enterpriseProductId}
                    propertyName={property.name}
                    propertyId={property.id}
                    productName={centralProductName}
                />
            );
        },
    }),
];
